import axios from 'axios'
import { getBase } from '../utils/requests'

axios.defaults.withCredentials = true

const apiBase = `${getBase()}/elements/images`

const config = {
  withCredentials: true
}

export const fetchImages = async (query, page, order) => {
  const params = `search=${query}&page=${page}&order_by=${order}`
  const url = `${apiBase}?${params}`
  try {
    const { data } = await axios.get(url, { withCredentials: true })
    return data
  } catch (e) {
    console.log(e)
    throw e
  }
}

export const fetchIllustrationCollections = async (query, page) => {
  let params = `?pageNo=${page}`
  if(query){
    params += `&search=${query}`
  }
  const url = `${getBase()}/elements/illustrations${params}`
  return await axios.get(url, { withCredentials: true })
}

export const fetchTeamAssets = async (team, page) => {
  const params = `?pageNo=${page}&teamId=${team}`
  const url = `${getBase()}/elements/team-assets${params}`
  return await axios.get(url, { withCredentials: true })
}

export const fetchIllustrations = async (collectionId) => {
  const params = `?collectionId=${collectionId}`
  const url = `${getBase()}/elements/illustrations/collection${params}`
  return await axios.get(url, { withCredentials: true })
}

export const getRawImage = async (l, isBackground = false) => {
  let layer = {}
  if(isBackground){
    layer = l
  }else{
    const { 
      dataSource,
      frameWidth, 
      frameHeight,
      assetId,
      id,
      displayWidth,
      displayHeight,
      filters,
      xPos,
      yPos,
      rotation,
      xCrop,
      yCrop
    } = l
    layer = {
      dataSource,
      frameWidth,
      type: l.type,
      frameHeight,
      displayWidth,
      displayHeight,
      assetId,
      id,
      filters: {
        ...filters
      },
      position: {
        xPos,
        yPos,
        rotation,
        xCrop,
        yCrop
      }
    }
  }
  const data = {
    layer,
    isBackground,
    download: true
  }
  return await axios.post(`${getBase()}/elements/download-image`, data, config)
}

export const uploadImage = async (file, designId, setProgress = undefined, parent = undefined, projectId = undefined) => {
  document.querySelector('.hidden-upload').style.display = 'none'
  const fd = new FormData()
  fd.append('image', file)
  let url = `${getBase()}/elements/upload/image?id=${designId}`
  if(parent){
    url += `&parent=${parent}`
  }
  if(projectId){
    url += `&project=${projectId}`
  }
  try {
    const { data } = await axios.post(url, fd, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true,
      onUploadProgress: data => {
        if(setProgress){
          setProgress(data)
        }
      }
    })
    return data
  } catch(e) {
    console.log(e)
    throw e
  }
}

export const deleteUserAsset = async (assetId) => {
  try{
    const { data } = await axios.post(`${getBase()}/elements/delete/image`, { assetId }, {
      withCredentials: true
    })
    return data.assetId
  }catch(err){
    console.log(err)
    throw err
  }
}

export const fetchUserImages = async (pageNo, isProject = false) => {
  let url = `${getBase()}/elements/user-images?pageNo=${pageNo}`
  if(isProject){
    url += `&project=${isProject}`
  }
  return await axios.get(url,
  {
    withCredentials: true
  })
}

export const getDefaultTemplates = async (keyword) => {
  let path = `/design/default-templates`
  return await axios.get(`${getBase()}${path}`, {
    withCredentials: true
  })
}

export const fetchFonts = async (page = 0, keyword, familyFilter = null, prevIdx = null) => {
  let url = `${getBase()}/elements/fonts?page=${page}`
  if(keyword && keyword.length){
    url += `&keyword=${keyword}`
  }
  if(familyFilter && familyFilter.length){
    url += `&family=${familyFilter}`
  }
  if(prevIdx){
    url += `&prevIdx=${prevIdx}`
  }
  try{
    const { data } = await axios.get(url, {
      withCredentials: true
    })
    return data
  } catch(e) {
    console.log(e)
    throw e
  }
}

export const fetchGifs = async (search, page, limit = null) => {
  let url = `${getBase()}/elements/gifs?`
  if(search.length){
    url += 'search=' + search
  }
  url += search.length ? `&page=${page}` : `page=${page}`
  if(limit){
    url += `&limit=${limit}`
  }
  try{
    const { data } = await axios.get(url, {
      withCredentials: true
    })
    return data
  }catch(e){
    console.log(e)
    throw e
  }
}

export const fetchStickers = async (search, page, limit = null) => {
  let url = `${getBase()}/elements/stickers?`
  if(search.length){
    url += 'search=' + search
  }
  url += search.length ? `&page=${page}` : `page=${page}`
  if(limit){
    url += `&limit=${limit}`
  }
  try{
    const { data } = await axios.get(url, {
      withCredentials: true
    })
    return data
  }catch(e){
    console.log(e)
    throw e
  }
}

export const checkIfImageExists = async (url) => {
  try {
    await axios.get(url, {
      withCredentials: true
    })
    return true
  }catch(err){
    console.log(err)
    return false
  }
}